import React, { lazy } from 'react';

// project imports
import MainLayout from '../layout/MainLayout';
import Loadable from '../ui-component/Loadable';

import { ProtectedRoute } from './ProtectedRoute';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('../views/dashboard/Default')));

// super user panels
const SuperUserPanel = Loadable(lazy(() => import('../views/superUserPanel/Default')));
const EditUserPanel = Loadable(lazy(() => import('../views/superUserPanel/editUserPanel')));
const CreateNewUserPanel = Loadable(lazy(() => import('../views/superUserPanel/createNewUserPanel')));

const AllOrganizationsPage = Loadable(lazy(() => import('../views/organizations/Organizations')));
const AllOrganizationsContactsPage = Loadable(lazy(() => import('../views/organizations/Contacts')));
const SupervisorReviewSpecification = Loadable(lazy(() => import('../views/supervisor/reviewSpecification')));
const ExecutiveReviewContract = Loadable(lazy(() => import('../views/executive/reviewContract')));
const SignedContractsPage = Loadable(lazy(() => import('../views/contracts/signedContracts')));
const ContractsNeedsSigningPage = Loadable(lazy(() => import('../views/contracts/needsSigning')));
const ReviewRequest = Loadable(lazy(() => import('../views/requestsManager/reviewRequest')));
const ViewRequestedServiceInformation = Loadable(lazy(() => import('../views/organizations/RequestedServices/ViewRequestedServiceInformation')));

// const OrganizationOrderServicePage = Loadable(lazy(() => import('../views/organizationUserViews/orderService')));

const NetworkServicePage = Loadable(lazy(() => import('../views/services/Network')));
const WiFiServicePage = Loadable(lazy(() => import('../views/services/WiFi')));
const VPNServicePage = Loadable(lazy(() => import('../views/services/VPN')));
const EduroamPage = Loadable(lazy(() => import('../views/services/Eduroam')));

// const AllWebOrganizationsPage = Loadable(lazy(() => import('../views/eServices/Web/AllOrganizations')));
// const AllWebsPage = Loadable(lazy(() => import('../views/eServices/Web/AllWebs')));

const MailPage = Loadable(lazy(() => import('../views/services/Email')));
const WebPage = Loadable(lazy(() => import('../views/services/Web')));
const BullyBoxPage = Loadable(lazy(() => import('../views/services/BullyBox')));
const SSOPage = Loadable(lazy(() => import('../views/services/SSO')));
const EIdentityManagementPage = Loadable(lazy(() => import('../views/services/EIdentityManagement')));
const CloudInfrastructurePage = Loadable(lazy(() => import('../views/services/CloudInfrastructure')));
const InfrastructureRentPage = Loadable(lazy(() => import('../views/services/InfrastructureRent')));
const BackupPage = Loadable(lazy(() => import('../views/services/Backup')));
const FediPage = Loadable(lazy(() => import('../views/services/Fedi')));
const MoodlePage = Loadable(lazy(() => import('../views/services/Moodle')));
const VideoStoragePage = Loadable(lazy(() => import('../views/services/VideoStorage')));
const CertificatesPage = Loadable(lazy(() => import('../views/services/Certificates')));
const NetworkDevicesSecurityAuditPage = Loadable(lazy(() => import('../views/services/NetworkDevicesSecurityAudit')));
const VirtualFirewallPage = Loadable(lazy(() => import('../views/services/VirtualFirewall')));
const ITResistanceSimulationPage = Loadable(lazy(() => import('../views/services/ITResistanceSimulation')));
const NotificationsPage = Loadable(lazy(() => import('../views/notifications')));
const RequestedServicesPage = Loadable(lazy(() => import('../views/organizations/RequestedServices')));
const DockerPage = Loadable(lazy(() => import('../views/services/Docker')));

// const FederationPage = Loadable(lazy(() => import('../views/eServices/Identity/Federations')));
// const SSOPage = Loadable(lazy(() => import('../views/eServices/Identity/SSO')));

const OrganizationPage = Loadable(lazy(() => import('../views/organization')));

const SettingsPage = Loadable(lazy(() => import('../views/settings/Settings')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <ProtectedRoute children={<DashboardDefault />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_ORGANIZATION_ROLE_NAME.toString(), process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
        },
        {
            path: '/super-user-settings',
            element: <ProtectedRoute children={<SuperUserPanel />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString()]} />
        },
        {
            path: '/super-user-settings/edit-user/:user_id',
            element: <ProtectedRoute children={<EditUserPanel />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString()]} />
        },
        {
            path: '/super-user-settings/create-user',
            element: <ProtectedRoute children={<CreateNewUserPanel />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString()]} />
        },
        {
            path: 'settings',
            element: <ProtectedRoute children={<SettingsPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString()]} />
        },
        // {
        //     path: 'organization-order-service',
        //     element: <ProtectedRoute children={<OrganizationOrderServicePage />} allowedRoles={[process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_ORGANIZATION_ROLE_NAME.toString()]} />
        // },
        {
            path: 'organizacijos',
            children: [
                {
                    path: 'institucijos',
                    element: <ProtectedRoute children={<AllOrganizationsPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'sutartys/pasirašytos',
                    element: <ProtectedRoute children={<SignedContractsPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'sutartys/formuojamos',
                    element: <ProtectedRoute children={<ContractsNeedsSigningPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} /> 
                },
                {
                    path: 'kontaktai',
                    element: <ProtectedRoute children={<AllOrganizationsContactsPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                }
            ]
        },
        {
            path: 'paslaugos',
            children: [
                {
                    path: 'tinklas',
                    element: <ProtectedRoute children={<NetworkServicePage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]}/>
                },
                {
                    path: 'wi-fi',
                    element: <ProtectedRoute children={<WiFiServicePage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'vpn',
                    element: <ProtectedRoute children={<VPNServicePage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'eduroam',
                    element: <ProtectedRoute children={<EduroamPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                }
            ]
        },
        {
            path: 'organization/:organization',
            element: <ProtectedRoute children={<OrganizationPage />} allowedRoles={[process.env.REACT_APP_ORGANIZATION_ROLE_NAME.toString(), process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString(), process.env.REACT_APP_ORGANIZATION_ROLE_NAME.toString()]} />
        },
        {
            path: 'prieglobos-paslaugos',
            children: [
                // {
                //     path: 'web-paslauga/organizacijos',
                //     element: <ProtectedRoute children={<AllWebOrganizationsPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString()]} />
                // },
                {
                    path: 'e-paslaugos/pastas',
                    element: <ProtectedRoute children={<MailPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'e-paslaugos/tinklapiu-priegloba',
                    element: <ProtectedRoute children={<WebPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'e-paslaugos/patyciu-dezutes-priegloba',
                    element: <ProtectedRoute children={<BullyBoxPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                //----------------------------
                {
                    path: 'infrastrukturos-paslaugos/debesijos-infrastrukturos-paslaugos',
                    element: <ProtectedRoute children={<CloudInfrastructurePage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'infrastrukturos-paslaugos/infrastrukturos-nuoma',
                    element: <ProtectedRoute children={<InfrastructureRentPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'infrastrukturos-paslaugos/atsarginiu-kopiju-priegloba',
                    element: <ProtectedRoute children={<BackupPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'infrastrukturos-paslaugos/konteineriu-infrastrukturos-paslauga',
                    element: <ProtectedRoute children={<DockerPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                //----------------------------
                {
                    path: 'e-tapatybiu-paslaugos/vieningo-prisijungimo-paslauga',
                    element: <ProtectedRoute children={<SSOPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'e-tapatybiu-paslaugos/e-tapatybiu-valdymas',
                    element: <ProtectedRoute children={<EIdentityManagementPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                }
                // {
                //     path: 'tapatybes/sso',
                //     element: <ProtectedRoute children={<SSOPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString()]} />
                // },
                // {
                //     path: 'tapatybes/federacijos',
                //     element: <ProtectedRoute children={<FederationPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString()]} />
                // }
            ]
        },
        {
            path: 'fedi',
            element: <ProtectedRoute children={<FediPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
        },
        {
            path: 'vma-paslaugos',
            children: [
                {
                    path: 'moodle',
                    element: <ProtectedRoute children={<MoodlePage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'vaizdu-irasu-saugojimas',
                    element: <ProtectedRoute children={<VideoStoragePage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                }
            ]
        },
        {
            path: 'it-saugos-paslaugos',
            children: [
                {
                    path: 'skaitmeniniai-sertifikatai',
                    element: <ProtectedRoute children={<CertificatesPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'tinklo-irenginiu-saugumo-auditas',
                    element: <ProtectedRoute children={<NetworkDevicesSecurityAuditPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'virtuali-ugniasiene',
                    element: <ProtectedRoute children={<VirtualFirewallPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'it-atsparumo-simuliacijos',
                    element: <ProtectedRoute children={<ITResistanceSimulationPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                }
            ]
        },
        {
            path: 'pranesimai',
            element: <ProtectedRoute children={<NotificationsPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_ORGANIZATION_ROLE_NAME.toString(), process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
        },
        {
            path: 'peržiūrėti',
            children: [
                {
                    path: 'specification/:id',
                    element: <ProtectedRoute children={<SupervisorReviewSpecification />} allowedRoles={[process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'contract/:id',
                    element: <ProtectedRoute children={<ExecutiveReviewContract />} allowedRoles={[process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString()]} />
                }
            ]
        },
        {
            path: 'užklausos',
            children: [
                {
                    path: 'redaguoti/:id',
                    element: <ProtectedRoute children={<ReviewRequest />} allowedRoles={[process.env.REACT_APP_REQUESTS_MANAGER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'peržiūrėti/:id',
                    element: <ProtectedRoute children={<ViewRequestedServiceInformation />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                },
                {
                    path: 'visos',
                    element: <ProtectedRoute children={<RequestedServicesPage />} allowedRoles={[process.env.REACT_APP_SUPER_USER_ROLE_NAME.toString(), process.env.REACT_APP_SUPERVISOR_ROLE_NAME.toString(), process.env.REACT_APP_EXECUTIVE_ROLE_NAME.toString(), process.env.REACT_APP_TC_ADMIN_ROLE_NAME.toString(), process.env.REACT_APP_VIEWER_ROLE_NAME.toString()]} />
                }
            ]
        }
        // {
        //     path: 'e-paslaugos',
        //     children: [
        //         {
        //             path: 'web-paslauga/organizacijos',
        //             element: <ProtectedRoute><AllWebOrganizationsPage /></ProtectedRoute>
        //         },
        //         {
        //             path: 'web-paslauga/visi-web',
        //             element: <ProtectedRoute><AllWebsPage /></ProtectedRoute>
        //         },
        //         {
        //             path: 'pastas',
        //             element: <ProtectedRoute><MailPage /></ProtectedRoute>
        //         },
        //         {
        //             path: 'tapatybes/sso',
        //             element: <ProtectedRoute><SSOPage /></ProtectedRoute>
        //         },
        //         {
        //             path: 'tapatybes/federacijos',
        //             element: <ProtectedRoute><FederationPage /></ProtectedRoute>
        //         }
        //     ]
        // },
        // {

        // },
        // {
        //     path: 'dashboard',
        //     children: [
        //         {
        //             path: 'default',
        //             element: <DashboardDefault />
        //         }
        //     ]
        // },
        // {
        //     path: 'utils',
        //     children: [
        //         {
        //             path: 'util-typography',
        //             element: <UtilsTypography />
        //         }
        //     ]
        // },
        // {
        //     path: 'utils',
        //     children: [
        //         {
        //             path: 'util-color',
        //             element: <UtilsColor />
        //         }
        //     ]
        // },
        // {
        //     path: 'utils',
        //     children: [
        //         {
        //             path: 'util-shadow',
        //             element: <UtilsShadow />
        //         }
        //     ]
        // },
        // {
        //     path: 'icons',
        //     children: [
        //         {
        //             path: 'tabler-icons',
        //             element: <UtilsTablerIcons />
        //         }
        //     ]
        // },
        // {
        //     path: 'icons',
        //     children: [
        //         {
        //             path: 'material-icons',
        //             element: <UtilsMaterialIcons />
        //         }
        //     ]
        // },
        // {
        //     path: 'sample-page',
        //     element: <SamplePage />
        // }
    ]
};

export default MainRoutes;